// Warning icon lookup. Kept in its own file because LocationMap.tsx imports
// react-map-gl's default export as `Map`, which would shadow the JS Map here.

export const DEFAULT_EW_ICON = "/icons/ih.png"   // fallback when a type/severity has no icon

export const iconMap: Map<string, Map<string, string>> = new Map([
    ["GUS", new Map([
        ["yellow", "/icons/wg.png"],
        ["amber", "/icons/ag.png"],
        ["red", "/icons/eg.png"],
    ])],
    ["LIG", new Map([
        ["yellow", "/icons/wlh.png"],
        ["amber", "/icons/alh.png"],
        ["red", "/icons/elh.png"],
    ])],
    ["FLW", new Map([
        ["yellow", "/icons/wf.png"],
        ["amber", "/icons/af.png"],
        ["red", "/icons/ef.png"],
    ])],
    ["TW", new Map([
        ["yellow", "/icons/wt.png"],
        ["amber", "/icons/at.png"],
        ["red", "/icons/et.png"],
    ])],
    ["HRW", new Map([
        ["yellow", "/icons/wh.png"],
        ["amber", "/icons/ah.png"],
        ["red", "/icons/eh.png"],
    ])],
    ["MWA", new Map([
        ["yellow", "/icons/wm.png"],
        ["amber", "/icons/am.png"],
        ["red", "/icons/em.png"],
    ])],
    ["LSW", new Map([
        ["yellow", "/icons/wl.png"],
        ["amber", "/icons/al.png"],
        ["red", "/icons/el.png"],
    ])],
    ["HWN", new Map([
        ["yellow", "/icons/ww.png"],
        ["amber", "/icons/aw.png"],
        ["red", "/icons/ew.png"],
    ])],
    ["CUS", new Map([
        ["yellow", "/icons/wc.png"],
        ["amber", "/icons/ac.png"],
        ["red", "/icons/ec.png"],
    ])],
    ["INC", new Map([
        ["IHRW", "/icons/iconm_heavyrain.png"],
        ["IFLW", "/icons/flood_icon.png"],
        ["ILSS", "/icons/flood_icon.png"],
        ["EXPL", "/icons/explosion_icon.png"],
        ["ILSW", "/icons/landslide_icon.png"],
        ["ITHS", "/icons/lightning_icon.png"],
        ["NUCL", "/icons/nuclear_icon.png"],
        ["ITSM", "/icons/tsunami_icon.png"],
        ["IVIR", "/icons/virus_icon.png"],
        ["IFFIR", "/icons/wildfire_icon.png"],
        ["BIOL", "/icons/virus_icon.png"],
        ["IETQ", "/icons/earth_icon.png"],
        ["ICYC", "/icons/cyclone_icon.png"],
        ["IFIR", "/icons/wildfire_icon.png"],
    ])],
])

/** true = draw the "white" icon for green / no alert, false = draw nothing. */
const SHOW_WHITE_FOR_NO_ALERT = false

const SEVERITY_ALIAS: Record<string, string> = {
    yellow: "yellow",
    amber: "amber",
    red: "red",
    none: ""
}

/**
 * Icon for a warning type + severity, e.g. HRW + amber -> /icons/ah.png.
 * Incident codes (IHRW, NUCL, ...) come from the INC group.
 * Returns null when no icon should be drawn.
 */
export const ewIcon = (type?: string, severity?: string): string | null => {
    const t = type?.trim().toUpperCase() ?? ""
    const sev = SEVERITY_ALIAS[severity?.trim().toLowerCase() ?? ""]

    const incident = iconMap.get("INC")?.get(t)
    if (incident) return incident

    if (!sev || (sev === "white" && !SHOW_WHITE_FOR_NO_ALERT)) return null

    return iconMap.get(t)?.get(sev) || DEFAULT_EW_ICON
}
